import React, { useEffect, useState } from "react"
import { SSRProvider } from "react-bootstrap"
import FormModal from "../../components/FormModal"
import Layout from "../../components/Layout"
import RTOOfficesCityContent from "../../components/RTOOfficesCityContent"
import Seo from "../../components/Seo"

const CityTemplate = () => {
  const currentUrl = typeof window !== "undefined" && window?.location?.pathname
  const state = String(currentUrl).split("/")
  const city = state[state.length - 1]
  const cityName = city.substring(city.lastIndexOf("-") - 3, 0)
  const [modalShow, setModalShow] = useState(false)

  const handleModal = () => {
    setModalShow(true)
  }

  const [stateData, setStateData] = useState([])
  console.log(state[state.length - 2])
  const fetchRtoStateData = async () => {
    await fetch(
      `${window.location.origin}/api/v5/rto/offices?state=${
        state[state.length - 2]
      }`
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        setStateData(data)
      })
      .catch(error => {
        console.error("Fetch error:", error)
      })
  }

  useEffect(() => {
    fetchRtoStateData()
  }, [])
  const cityData =
    stateData && stateData.filter(el => el.city_slug === cityName)
  const cityObject = cityData.reduce((prev, curr) => ({ ...prev, ...curr }), {})
  return (
    <>
      <SSRProvider>
        <Layout handleModal={handleModal} mainForm={true}>
          <Seo
            title={`RTO Office ${cityObject.city} ${cityObject.code}: Check Phone Number, Address & RTO Code`}
            description={`RTO Offices In ${cityObject.city} ${cityObject.code}. Check the list of RTO Offices in ${cityObject.city} ${cityObject.code} with RTO Code, Phone Number & Address. Also find out the duties and functions of RTO near ${cityObject.city} ${cityObject.code}`}
            canonicalUrl={`https://loconav.com/rto-offices/${cityObject.state_slug}/${cityObject.city_slug}-${cityObject.code}`}
            index="index,follow"
          />
          {stateData.length > 0 && (
            <RTOOfficesCityContent filterCityData={cityObject} />
          )}
          <FormModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            page_name={`rto-city-page`}
          />
        </Layout>
      </SSRProvider>
    </>
  )
}

export default CityTemplate
